import { Route } from 'react-router-dom';
import Home from 'src/views/applicant/Dashboard/home/home';
import ApplicantProfile from 'src/views/applicant/Dashboard/myProfile/myProfile';
import CreateCampaign from 'src/views/applicant/Dashboard/createCampaign/createCampaign';
import CampaignsDash from 'src/views/applicant/Dashboard/createCampaign/campaignsDash/campaignsDash';
import { ProtectedOnboardingRoute } from 'src/components/shared/compositionComponents/ProtectedOnboardingRoute/ProtectedOnboardingRoute';
import { AllowedUser } from '../ProtectedRoute';

const AllowedUserConfig: AllowedUser = {
  user: 'applicant',
  person: undefined
};

export const DashboardApplicantRoutes = (
  <>
    <Route
      path="/solicitante/dashboard"
      element={
        <ProtectedOnboardingRoute protectDashboard allowedUsers={[AllowedUserConfig]}>
          <Home />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="/solicitante/dashboard/mi-perfil"
      element={
        <ProtectedOnboardingRoute protectDashboard allowedUsers={[AllowedUserConfig]}>
          <ApplicantProfile />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="/solicitante/dashboard/crear-campaña"
      element={
        <ProtectedOnboardingRoute protectDashboard allowedUsers={[AllowedUserConfig]}>
          <CreateCampaign />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="/solicitante/dashboard/campañas"
      element={
        <ProtectedOnboardingRoute protectDashboard allowedUsers={[AllowedUserConfig]}>
          <CampaignsDash />
        </ProtectedOnboardingRoute>
      }
    />
  </>
);
